var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDatabaseSelection = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "14px",
    viewBox: "0 0 15 14",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Available Filters - 01")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Demo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.-Settings---01",
    transform: "translate(-286.000000, -644.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(285.000000, 637.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Hardware-/-developer_board",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L17.1904045,0 L17.1904045,18.05 L0,18.05 L0,0 Z M0,0 L17.1904045,0 L17.1904045,18.05 L0,18.05 L0,0 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7578708,6.76875 L15.7578708,5.26458333 L14.3253371,5.26458333 L14.3253371,3.76041667 C14.3253371,2.933125 13.6806969,2.25625 12.8928034,2.25625 L2.86506741,2.25625 C2.07717387,2.25625 1.43253371,2.933125 1.43253371,3.76041667 L1.43253371,14.2895833 C1.43253371,15.116875 2.07717387,15.79375 2.86506741,15.79375 L12.8928034,15.79375 C13.6806969,15.79375 14.3253371,15.116875 14.3253371,14.2895833 L14.3253371,12.7854167 L15.7578708,12.7854167 L15.7578708,11.28125 L14.3253371,11.28125 L14.3253371,9.77708333 L15.7578708,9.77708333 L15.7578708,8.27291667 L14.3253371,8.27291667 L14.3253371,6.76875 L15.7578708,6.76875 Z M12.8928034,14.2895833 L2.86506741,14.2895833 L2.86506741,3.76041667 L12.8928034,3.76041667 L12.8928034,14.2895833 Z M4.29760112,9.77708333 L7.87893538,9.77708333 L7.87893538,12.7854167 L4.29760112,12.7854167 L4.29760112,9.77708333 Z M8.59520223,5.26458333 L11.4602696,5.26458333 L11.4602696,7.52083333 L8.59520223,7.52083333 L8.59520223,5.26458333 Z M4.29760112,5.26458333 L7.87893538,5.26458333 L7.87893538,9.025 L4.29760112,9.025 L4.29760112,5.26458333 Z M8.59520223,8.27291667 L11.4602696,8.27291667 L11.4602696,12.7854167 L8.59520223,12.7854167 L8.59520223,8.27291667 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDatabaseSelection, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/database_selection.f9fab320.svg";
export { ForwardRef as ReactComponent };